import React from 'react';
import classNames from 'classnames';
import { useDispatch, useSelector } from 'react-redux';
import { conversationClosedFilter } from 'constants/forms';

import s from './styles.module.scss';

import type { RootDispatch, RootState } from 'store';

const ConversationStatusFilter: React.FC = () => {
  const { filters } = useSelector((state: RootState) => state.smsDashboard);
  const {
    smsDashboard: { updateConversationsFilters },
  } = useDispatch<RootDispatch>();

  return (
    <ul className={s.tabs}>
      {conversationClosedFilter.map((el) => (
        <li
          key={el.id}
          className={classNames(s.tab, el.value === filters.closed && s.active)}
          onClick={() =>
            updateConversationsFilters({ ...filters, closed: el.value })
          }
        >
          {el.label}
        </li>
      ))}
    </ul>
  );
};

export default ConversationStatusFilter;
